import { LOCALES } from "../locales";

const spanishMessages = {
  [LOCALES.SPANISH]: {
    botQuestion:
      "¡Bienvenido! Puedes preguntarme cualquier cosa. ¡Puedo ayudarte!",
    chatOpen: "Abrir asistente del portafolio",
    chatClose: "Cerrar asistente del portafolio",
    chatDialog: "Asistente del portafolio",
    chatPlaceholder: "Escribe tu mensaje...",
    chatSend: "Enviar",
    chatError: "No pude comunicarme con RafaBot. Inténtalo de nuevo.",
    chatRetry: "Reintentar",
    chatHeroAction: "Pregúntale a RafaBot",
    chatTitle: "RafaBot",
    chatStatus: "Guía del portafolio · En línea",
    chatLoading: "RafaBot está pensando",
    chatSources: "Explorar en el portafolio",
    chatProjectPreviews: "Proyectos del portafolio de Rafa",
    chatProjectOpen: "Ver proyecto",
    chatProjectScroll: "Desliza",
    chatExploreTitle: "Explora a Rafa",
    chatExploreIntro: "Elige un tema o escribe tu propia pregunta abajo.",
    chatExploreaboutLabel: "Sobre Rafa",
    chatExploreaboutHint: "Trayectoria e intereses",
    chatExploreaboutPrompt: "¿Quién es Rafa?",
    chatExploreprojectsLabel: "Proyectos destacados",
    chatExploreprojectsHint: "Descubre lo que Rafa ha creado",
    chatExploreprojectsPrompt: "Muéstrame los proyectos destacados de Rafa.",
    chatExploreskillsLabel: "Habilidades técnicas",
    chatExploreskillsHint: "Herramientas, lenguajes y fortalezas",
    chatExploreskillsPrompt: "¿Cuáles son las principales habilidades técnicas de Rafa?",
    chatExploreexperienceLabel: "Experiencia",
    chatExploreexperienceHint: "Trayectoria profesional",
    chatExploreexperiencePrompt: "Cuéntame sobre la experiencia profesional de Rafa.",
    chatExploreservicesLabel: "Servicios",
    chatExploreservicesHint: "Cómo puede ayudarte Rafa",
    chatExploreservicesPrompt: "¿Qué servicios profesionales ofrece Rafa?",
    hi: "¡HOLA MUNDO!",
    im: "Rafael Valdez",
    ing: "Ingeniero de Software",
    // hero: "¡Bienvenido a mi sitio web! Soy un ingeniero de software radicado en Houston, Texas, enfocado en diseñar, desarrollar y probar experiencias digitales de alta calidad.",
    hero: "¡Bienvenido a mi sitio web! Soy un desarrollador web full-stack enfocado en ayudar a las empresas a convertir ideas en productos digitales de alta calidad.",
    aboutd1:
      "Disfruto resolver problemas complejos, explorar nuevas tecnologías y diseñar experiencias de usuario de principio a fin, creando aplicaciones responsivas y visualmente atractivas.",
    aboutd2:
      "Trabajo a lo largo de todo el ciclo de desarrollo, desde la idea hasta el lanzamiento, incluyendo UX, frontend, backend y diseño de sistemas escalables. Construyo aplicaciones rápidas y mantenibles, enfocándome en resultados listos para producción y comunicación clara.",
    aboutd3:
      "Continúo profundizando mis conocimientos en IA y diseño de sistemas, con un enfoque en funcionalidades impulsadas por IA, orquestación de agentes y sistemas RAG, mientras perfecciono la forma en que evalúo decisiones arquitectónicas y diseño soluciones escalables, confiables y mantenibles a largo plazo.",
    aboutedu: "Educación:",
    abouthob: "Pasatiempos:",
    abouttech: "Algunas tecnologías con las que he trabajado recientemente:",
    aboutsc1:
      "Flatiron School, Desarrollo Web Full Stack, Houston, Estados Unidos",
    aboutsc2:
      "Lic. Administración de Empresas (UASLP), San Luis Potosí, México",
    aboutsc3: "Negocios Internacionales (UV), Valparaíso, Chile",
    aboutp1: "Cocina",
    aboutp2: "Viajes",
    aboutp3: "Tecnología",
    aboutp4: "Videojuegos",
    servicest1: "Páginas Web",
    servicest2: "Productos de IA",
    servicest3: "Proyectos de Código",
    servicestd1:
      "Sitios web modernos y responsivos que hacen que tu negocio luzca profesional, carguen rápido y conviertan visitantes en clientes.",
    servicestd2:
      "Soluciones de IA inteligentes que automatizan tareas repetitivas, reducen costos operativos y ayudan a que tu negocio funcione de manera más eficiente.",
    servicestd3:
      "Soluciones de programación a medida que agregan las funciones que necesitas, conectan tus sistemas y optimizan las operaciones de tu negocio.",
    sA1: "Sitios web empresariales",
    sA2: "Páginas de aterrizaje",
    sA3: "Portafolios",
    sB1: "Chatbots",
    sB2: "Automatizaciones",
    sB3: "Asistentes personales",
    sB4: "Sistemas RAG",
    sC1: "Aplicaciones full-stack",
    sC2: "Integraciones",
    sC3: "APIs",
    drop1: "Categorías",
    drop2: "Todas",
    drop3: "Frontend",
    drop4: "Backend",
    drop5: "Herramientas",
    dropp4: "Aplicaciones Móviles",
    dropp3: "Aplicaciones Web",
    projectsFiltersLabel: "Categorías de proyectos",
    projectsFilterAll: "Todos",
    projectsFilterWeb: "Web",
    projectsFilterMobile: "Móvil",
    projectsFilterAI: "IA",
    projectsFeaturedTitle: "Trabajo Destacado",
    projectsArchiveTitle: "Todos los Proyectos",
    projectsArchiveFilteredTitle: "Proyectos de {category}",
    projectsShowMore: "Mostrar {count} más",
    projectsShowLess: "Mostrar menos",
    projectsEmpty: "No hay proyectos en esta categoría.",
    projectsImageAlt: "Vista previa del proyecto {title}",
    projectsLinkVideo: "Video",
    projectsLinkDocument: "Documento",
    projectsLinkCode: "Código",
    projectsLinkWebsite: "Sitio Web",
    Resumet: "Cosas interesantes",
    Resumecon:
      "Aquí puedes encontrar la versión anterior de este sitio web, consultar mi LinkedIn y currículum.",
    resume: "Currículum Vitae",
    resumeDescription: "Consulta o descarga mi currículum.",
    past: "Versión anterior",
    pastDescription: "Explora la versión anterior de este sitio web.",
    linkedinDescription: "Conecta conmigo y visita mi perfil profesional.",
    touch:
      "Si tienes una pregunta, quieres decir hola o hablar sobre programación, no dudes en contactarme. ¡Oh! Casi lo olvido, ¡aquí está tu taco!",
    touchLoc: "Ubicación",
    touchPho: "Teléfono",
    whats: "También disponible en WhatsApp",
    title1: "SOBRE MÍ",
    title2: "SERVICIOS",
    title3: "TECNOLOGÍAS",
    techP1:
      "Una selección de proyectos que refleja mi enfoque en el desarrollo de productos, el diseño de sistemas y la ingeniería centrada en el usuario para web, móvil e IA.",
    title4: "PROYECTOS",
    title5: "¡HABLEMOS!",
    botWelcome:
      "¡Hola! Soy una IA creada a partir de la conciencia de Rafa. Puedes preguntarme cualquier cosa sobre su trayectoria. profesional, habilidades y proyectos.",
    nav1: "Sobre mí",
    nav2: "Servicios",
    nav3: "Tecnologías",
    nav4: "Proyectos",
    nav5: "Varios",
    nav6: "Contacto",
  },
};

export default spanishMessages;
